module.exports = __webpack_public_path__ + "NanumSquareR.4217b4ceadd4de6e7769";


//////////////////
// WEBPACK FOOTER
// /Users/gygo/zzal/src_brand_web/src/assets/font/NanumSquareR.woff
// module id = ../../../../../src/assets/font/NanumSquareR.woff
// module chunks = styles